import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/mlLeftImg.png";
import rightimg from "../../../assets/mlRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import mlBenefitsImg1 from "../../../assets/mlBenefitsImg1.png";
import mlBenefitsImg2 from "../../../assets/mlBenefitsImg2.png";
import mlBenefitsImg3 from "../../../assets/mlBenefitsImg3.png";
import mlBenefitsImg4 from "../../../assets/mlBenefitsImg4.png";
import mlBenefitsImg5 from "../../../assets/mlBenefitsImg5.png";
import mlBenefitsImg6 from "../../../assets/mlBenefitsImg6.png";
import mlBenefitsImg7 from "../../../assets/mlBenefitsImg7.png";
import mlBenefitsImg8 from "../../../assets/mlBenefitsImg8.png";
import mlBenefitsImg9 from "../../../assets/mlBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import mlFunActivitiesImg1 from "../../../assets/mlFunActivitiesImg1.png";
import mlFunActivitiesImg2 from "../../../assets/mlFunActivitiesImg2.png";
import mlFunActivitiesImg3 from "../../../assets/mlFunActivitiesImg3.png";
import mlFunActivitiesImg4 from "../../../assets/mlFunActivitiesImg4.png";
import mlFunActivitiesImg5 from "../../../assets/mlFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const MachineLearningPortal = () => {
  const machinelearningpage = heroContent.machinelearningpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "6",
      description:
        " ML Basics - Intro to data prep, supervised & unsupervised learning, deep & reinforcement learning.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "6",
      description:
        " Supervised Learning - Learn regression, classification, decision trees, SVMs & neural networks.",
    },
    {
      title: "Module 3",
      activities: "9",
      classes: "5",
      description:
        " Unsupervised Learning - Master clustering, dimensionality reduction, anomaly detection & more.",
    },
    {
      title: "Module 4",
      activities: "7",
      classes: "4",
      description:
        "Deep Learning - Build CNNs, RNNs & generative models for complex data",
    },
  ];

  const benefitsData = [
    {
      title: "Master ML Basics",
      description:
        "Get started with key machine learning concepts and techniques.",
      icon: mlBenefitsImg1,
    },
    {
      title: "Build Predictive Models",
      description: "Create models that make accurate future predictions.",
      icon: mlBenefitsImg2,
    },
    {
      title: "Classify Real Data",
      description: "Use algorithms to label and organize data effectively.",
      icon: mlBenefitsImg3,
    },
    {
      title: "Explore Data Patterns",
      description: "Find trends and patterns in complex datasets.",
      icon: mlBenefitsImg4,
    },
    {
      title: "Choose Right Algorithms",
      description: "Pick the best-fit algorithm for different data types.",
      icon: mlBenefitsImg5,
    },
    {
      title: "Train Neural Networks",
      description: "Teach machines to learn from data using deep learning.",
      icon: mlBenefitsImg6,
    },
    {
      title: "Understand Core Stats",
      description: "Learn essential statistics for data analysis and ML.",
      icon: mlBenefitsImg7,
    },
    {
      title: "Visualize Insights",
      description: "Turn data into visual stories using charts and graphs.",
      icon: mlBenefitsImg8,
    },
    {
      title: "Make Smart Predictions",
      description: "Apply ML to solve problems and make data-driven decisions.",
      icon: mlBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Data Cleaning",
      image: mlFunActivitiesImg1,
    },
    {
      title: "Clustering",
      image: mlFunActivitiesImg2,
    },
    {
      title: "Data Classification",
      image: mlFunActivitiesImg3,
    },
    {
      title: "SVM",
      image: mlFunActivitiesImg4,
    },
    {
      title: "CNN",
      image: mlFunActivitiesImg5,
    },
  ];

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={machinelearningpage.titlePart1}
        description={machinelearningpage.description}
        buttonText={machinelearningpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Machine Learning"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Machine Learning"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default MachineLearningPortal;
